module.exports = __webpack_public_path__ + "static/img/xedk.4d67b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/xedk.png
// module id = 1281
// module chunks = 0